import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconSortUp = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.99983 8.45483L6.99982 18H8.99982L8.99983 8.3736L10.6667 10.0404L12.0809 8.62623L8.74755 5.29289C8.35702 4.90237 7.72386 4.90237 7.33333 5.29289L4 8.62623L5.41421 10.0404L6.99983 8.45483ZM13 18L13 10H15L15 18H13ZM17 13V18H19V13H17Z"
        />
      </svg>
    );
  }
);
